interface ColorRGB {
  r: number;
  g: number;
  b: number;
}
interface ColorARGB extends ColorRGB {
  a: number;
}

export class ColorConverter {
  static blendedRGB(argbHex: string, alpha: number, backgroundHex: string = '#FFFFFF'): ColorRGB {
    const fg = this.parseHexColor(argbHex);
    const bgHex = this.parseHexColor(backgroundHex);
    return this.blendOver(bgHex, fg, alpha);
  }

  static getRgb(color: ColorRGB): string {
    return `rgb(${color.r}, ${color.g}, ${color.b})`;
  }

  private static parseHexColor(input: string): ColorARGB {
    const s = input.trim().replace(/^#/, '');
    if (s.length === 3)
      return {
        a: 1,
        r: parseInt(s[0] + s[0], 16),
        g: parseInt(s[1] + s[1], 16),
        b: parseInt(s[2] + s[2], 16),
      };
    if (s.length === 4)
      return {
        a: parseInt(s[0] + s[0], 16) / 255,
        r: parseInt(s[1] + s[1], 16),
        g: parseInt(s[2] + s[2], 16),
        b: parseInt(s[3] + s[3], 16),
      };
    if (s.length === 6)
      return {
        a: 1,
        r: parseInt(s.slice(0, 2), 16),
        g: parseInt(s.slice(2, 4), 16),
        b: parseInt(s.slice(4, 6), 16),
      };
    if (s.length === 8)
      return {
        a: parseInt(s.slice(0, 2), 16) / 255,
        r: parseInt(s.slice(2, 4), 16),
        g: parseInt(s.slice(4, 6), 16),
        b: parseInt(s.slice(6, 8), 16),
      };
    return {
      a: 1,
      r: 255,
      g: 255,
      b: 255,
    };
  }

  private static blendOver(bg: ColorRGB, fg: ColorARGB, alpha: number): ColorRGB {
    return {
      r: Math.round(alpha * fg.r + (1 - alpha) * bg.r),
      g: Math.round(alpha * fg.g + (1 - alpha) * bg.g),
      b: Math.round(alpha * fg.b + (1 - alpha) * bg.b),
    };
  }
}
